import React from 'react';
import { EnvironmentOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import './SiteFooter.css';

const FOOTER_EMAIL = 'flashagency1@outlook.com';
const FOOTER_PHONE_DISPLAY = '+852 52134313';
const FOOTER_PHONE_TEL = '+85252134313';

function SiteFooter({ variant = 'default' }) {
  const { t } = useI18n();

  return (
    <footer className={`site-footer site-footer--${variant}`} role="contentinfo">
      <div className="site-footer__title">{t('footer.title')}</div>
      <div className="site-footer__company">{t('footer.companyName')}</div>
      <div className="site-footer__address">
        <EnvironmentOutlined className="site-footer__icon" aria-hidden />
        <span className="site-footer__address-text">{t('footer.address')}</span>
      </div>
      <div className="site-footer__links">
        <a className="site-footer__link" href={`mailto:${FOOTER_EMAIL}`}>
          <MailOutlined className="site-footer__icon" aria-hidden />
          <span className="site-footer__link-label">{t('footer.emailLabel')}</span>
          <span className="site-footer__link-value">{FOOTER_EMAIL}</span>
        </a>
        <a className="site-footer__link" href={`tel:${FOOTER_PHONE_TEL}`}>
          <PhoneOutlined className="site-footer__icon" aria-hidden />
          <span className="site-footer__link-label">{t('footer.phoneLabel')}</span>
          <span className="site-footer__link-value">{FOOTER_PHONE_DISPLAY}</span>
        </a>
      </div>
      <div className="site-footer__policy-links">
        <Link className="site-footer__policy-link" to="/about-us">
          {t('footer.aboutUs')}
        </Link>
        <Link className="site-footer__policy-link" to="/refund-policy">
          {t('footer.refundPolicy')}
        </Link>
        <Link className="site-footer__policy-link" to="/privacy-policy">
          {t('footer.privacyPolicy')}
        </Link>
        <Link className="site-footer__policy-link" to="/terms-and-conditions">
          {t('footer.termsAndConditions')}
        </Link>
      </div>
    </footer>
  );
}

export default SiteFooter;
